import { useState } from "react";

export default function ContactForm() {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    const form = e.currentTarget;
    const formData = new FormData(form);
    const data = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== "_redirect") data.append(key, value.toString());
    });

    try {
      const res = await fetch(
        "https://readdy.ai/api/form/d7r12jel0bai2p3haii0",
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: data.toString(),
        }
      );
      if (res.ok) {
        setSubmitted(true);
        form.reset();
        setCharCount(0);
      } else {
        setError("Submission failed. Please try again.");
      }
    } catch {
      setError("Network error. Please try again.");
    }
  };

  return (
    <div className="glass-card p-6 md:p-8">
      {submitted ? (
        <div className="text-center py-10">
          <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-emerald-accent/10 border border-emerald-accent/20 mb-4">
            <i className="ri-check-line text-2xl text-emerald-accent" />
          </div>
          <h3 className="text-lg font-bold text-white mb-2">Message Sent!</h3>
          <p className="text-sm text-silver-300">
            We will get back to you shortly.
          </p>
          <button
            onClick={() => setSubmitted(false)}
            className="mt-4 text-sm text-emerald-accent hover:text-emerald-hover transition-colors"
          >
            Send another message
          </button>
        </div>
      ) : (
        <form
          data-readdy-form
          id="contact-form"
          onSubmit={handleSubmit}
          className="space-y-4"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="contact-name"
                className="block text-sm font-medium text-silver-200 mb-1.5"
              >
                Name
              </label>
              <input
                id="contact-name"
                name="name"
                required
                className="w-full px-4 py-2.5 bg-graphite-800 border border-graphite-700 rounded-lg text-white text-sm placeholder:text-silver-400 focus:outline-none focus:border-emerald-accent/50 transition-colors"
                placeholder="Your name"
              />
            </div>
            <div>
              <label
                htmlFor="contact-email"
                className="block text-sm font-medium text-silver-200 mb-1.5"
              >
                Email
              </label>
              <input
                id="contact-email"
                name="email"
                type="email"
                required
                className="w-full px-4 py-2.5 bg-graphite-800 border border-graphite-700 rounded-lg text-white text-sm placeholder:text-silver-400 focus:outline-none focus:border-emerald-accent/50 transition-colors"
                placeholder="info@stackmapsystems.com"
              />
            </div>
          </div>
          <div>
            <label
              htmlFor="contact-company"
              className="block text-sm font-medium text-silver-200 mb-1.5"
            >
              Company
            </label>
            <input
              id="contact-company"
              name="company"
              className="w-full px-4 py-2.5 bg-graphite-800 border border-graphite-700 rounded-lg text-white text-sm placeholder:text-silver-400 focus:outline-none focus:border-emerald-accent/50 transition-colors"
              placeholder="Your company name"
            />
          </div>
          <div>
            <label
              htmlFor="contact-interest"
              className="block text-sm font-medium text-silver-200 mb-1.5"
            >
              I'm interested in
            </label>
            <select
              id="contact-interest"
              name="interest"
              required
              className="w-full px-4 py-2.5 bg-graphite-800 border border-graphite-700 rounded-lg text-white text-sm focus:outline-none focus:border-emerald-accent/50 transition-colors appearance-none"
            >
              <option value="">Select an option</option>
              <option value="off-the-shelf">Off-the-shelf Products</option>
              <option value="bespoke">Bespoke Development</option>
              <option value="demo">Book a Demo</option>
              <option value="enterprise">Enterprise Consultation</option>
            </select>
          </div>
          <div>
            <label
              htmlFor="contact-message"
              className="block text-sm font-medium text-silver-200 mb-1.5"
            >
              Message
            </label>
            <textarea
              id="contact-message"
              name="message"
              rows={4}
              maxLength={500}
              required
              onChange={(e) => setCharCount(e.target.value.length)}
              className="w-full px-4 py-2.5 bg-graphite-800 border border-graphite-700 rounded-lg text-white text-sm placeholder:text-silver-400 focus:outline-none focus:border-emerald-accent/50 transition-colors resize-none"
              placeholder="Tell us about your needs..."
            />
            <p className="text-xs text-silver-400 mt-1 text-right">
              {charCount}/500
            </p>
          </div>
          {error && <p className="text-sm text-red-400">{error}</p>}
          <button
            type="submit"
            className="w-full btn-primary disabled:opacity-60 disabled:cursor-not-allowed"
          >
            Send Message
          </button>
        </form>
      )}
    </div>
  );
}